'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { OPEN_MODAL, CLOSE_MODAL } from '../actions/ActionTypes';
import { RENAME_FILE_ATTEMPTED, RENAME_FILE_FAILED, RENAME_FILE_SUCCEEDED, RENAME_FOLDER_ATTEMPTED, RENAME_FOLDER_FAILED, RENAME_FOLDER_SUCCEEDED, MOVE_FILE_ATTEMPTED, MOVE_FILE_FAILED, MOVE_FILE_SUCCEEDED, MOVE_FOLDER_ATTEMPTED, MOVE_FOLDER_FAILED, MOVE_FOLDER_SUCCEEDED, REPLACE_FILE_ATTEMPTED, REPLACE_FILE_FAILED, REPLACE_FILE_SUCCEEDED, CHANGE_FOLDER_PARTITIONING_SUCCEEDED, CHANGE_FOLDER_PARTITIONING_ATTEMPTED, CHANGE_FOLDER_PARTITIONING_FAILED, SET_VIDEO2_OPT_IN_MODAL_OPEN } from 'FileManagerCore/actions/ActionTypes';
import { RequestStatus } from 'FileManagerCore/Constants';
import { VIDEO_OPT_IN } from '../enums/ModalTypes';
import { MODAL_REQUEST_TYPES } from '../types/redux/ModalDisplay';
const defaultState = ImmutableMap({
  openModalName: null,
  objectCategory: null,
  objectId: null,
  bulkSelectedFolderIds: ImmutableSet([]),
  bulkSelectedFileIds: ImmutableSet([]),
  requests: ImmutableMap({}),
  videoKey: null
});
export default function ModalDisplay(state = defaultState, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return state.merge(action.payload).set('openModalName', action.modalId);
    case SET_VIDEO2_OPT_IN_MODAL_OPEN:
      if (action.openModal) {
        return state.set('openModalName', VIDEO_OPT_IN);
      }
      return defaultState;
    case CLOSE_MODAL:
      return defaultState;
    case RENAME_FILE_ATTEMPTED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.renameFile], RequestStatus.PENDING);
    case RENAME_FILE_FAILED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.renameFile], RequestStatus.FAILED);
    case RENAME_FILE_SUCCEEDED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.renameFile], RequestStatus.SUCCEEDED);
    case RENAME_FOLDER_ATTEMPTED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.renameFolder], RequestStatus.PENDING);
    case RENAME_FOLDER_FAILED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.renameFolder], RequestStatus.FAILED);
    case RENAME_FOLDER_SUCCEEDED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.renameFolder], RequestStatus.SUCCEEDED);
    case MOVE_FILE_ATTEMPTED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.moveFile], RequestStatus.PENDING);
    case MOVE_FILE_FAILED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.moveFile], RequestStatus.FAILED);
    case MOVE_FILE_SUCCEEDED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.moveFile], RequestStatus.SUCCEEDED);
    case MOVE_FOLDER_ATTEMPTED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.moveFolder], RequestStatus.PENDING);
    case MOVE_FOLDER_FAILED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.moveFolder], RequestStatus.FAILED);
    case MOVE_FOLDER_SUCCEEDED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.moveFolder], RequestStatus.SUCCEEDED);
    case REPLACE_FILE_ATTEMPTED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.replaceFile], RequestStatus.PENDING);
    case REPLACE_FILE_FAILED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.replaceFile], RequestStatus.FAILED);
    case REPLACE_FILE_SUCCEEDED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.replaceFile], RequestStatus.SUCCEEDED);
    case CHANGE_FOLDER_PARTITIONING_SUCCEEDED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.partitionFolder], RequestStatus.SUCCEEDED);
    case CHANGE_FOLDER_PARTITIONING_ATTEMPTED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.partitionFolder], RequestStatus.PENDING);
    case CHANGE_FOLDER_PARTITIONING_FAILED:
      return state.setIn(['requests', MODAL_REQUEST_TYPES.partitionFolder], RequestStatus.FAILED);
    default:
      return state;
  }
}